<template>
  <v-container class="elevation-3">
    <CRUDDialog
    ref="crudDialog"
    :baseCrudKey="baseCrudKey"
    :canSave="false"
    onlyDialogHeaderName='Unposted Transactions'
    >
    <template v-slot:[`editedItem`]="{}">
      <CRUDList ref="crudList"
        noResultOverride="No payments found"
        tableTitle="Payments"
        :canAdd="false"
        :canEdit="false"
        :canSave="false"
        :showSelect="false"
        :displayTopPagination="false"
        :hideDefaultFooter="true"
        :enableFixedHeaders="true"
        :disableKeyboardFunc="false"
        :headers="paymentHeaders"
        :baseCrudKey="baseCrudPaymentListKey"
        :defaultSortBy="defaultSortByPay"
        tableWrapperDynamicClassname='taxroll-table-wrapper-two'
        tableDynamicHeight="150"
        />
      <div class="mt-5"/>
      <CRUDList ref="crudList"
        tableTitle="Adjustments"
        noResultOverride="No Adjustments found"
        :canAdd="false"
        :canEdit="false"
        :canSave="false"
        :showSelect="false"
        :displayTopPagination="false"
        :hideDefaultFooter="true"
        :enableFixedHeaders="true"
        :disableKeyboardFunc="false"
        :headers="adjHeaders"
        :baseCrudKey="baseCrudAdjListKey"
        :defaultSortBy="defaultSortByAdj"
        tableWrapperDynamicClassname='taxroll-table-wrapper-two'
        tableDynamicHeight="150"
      />
    </template>
    </CRUDDialog>
  </v-container>
</template>

<script>
import {
  mapState,
} from 'vuex';
import CRUDDialog from '../../../../common/base/crud-2.0/CRUDDialog.vue';
import { postAdjList, postPaymentsList } from '../../paymentutils/PaymentTransactionTableHeaders';
import CRUDList from '../../../../common/base/crud-2.0/CRUDList.vue';
import '../../../../../assets/style.css';

export default {
  name: 'PostingPeriodDialog',
  data() {
    return {
      baseCrudPaymentListKey: 'baseCrudPaymentListKey',
      baseCrudAdjListKey: 'baseCrudAdjListKey',
      paymentHeaders: postPaymentsList,
      adjHeaders: postAdjList,
    };
  },
  created() {
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'postingPeriodDialog',
    },
  },
  computed: {
    ...mapState({
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
    }),
    editItem() {
      return this.taxSettingItem;
    },
    defaultSortByPay() {
      return [
        {
          column: 'payDate',
          direction: 'desc',
        },
      ];
    },
    defaultSortByAdj() {
      return [
        {
          column: 'adjDate',
          direction: 'desc',
        },
      ];
    },
  },
  components: {
    CRUDDialog,
    CRUDList,
  },
  methods: {
  },
};
</script>
